import { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useUIStore } from '@/state/uiStore';
import { X } from 'lucide-react';

export default function NotificationStack() {
  const notifications = useUIStore((s) => s.notifications);
  const dismiss = useUIStore((s) => s.dismissNotification);

  useEffect(() => {
    const timers = notifications.map((n) =>
      setTimeout(() => dismiss(n.id), n.ttlMs),
    );
    return () => timers.forEach(clearTimeout);
  }, [notifications, dismiss]);

  return (
    <div className="fixed top-20 right-6 z-40 flex flex-col gap-3 w-80 pointer-events-none">
      <AnimatePresence initial={false}>
        {notifications.map((n) => (
          <motion.div
            key={n.id}
            data-testid={`toast-${n.id}`}
            initial={{ x: 60, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 60, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className={`pointer-events-auto rounded-lg border-l-4 px-4 py-3 bg-ink-deep shadow-ink-soft ${
              n.intensity === 'critical'
                ? 'border-blood text-blood'
                : n.intensity === 'high'
                  ? 'border-gold-bright text-gold-bright'
                  : 'border-cream-soft/60 text-cream'
            }`}
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="font-inter text-sm tracking-wider">{n.title}</p>
                {n.body ? (
                  <p className="font-inter text-xs text-cream-soft mt-1 leading-relaxed">{n.body}</p>
                ) : null}
              </div>
              <button onClick={() => dismiss(n.id)} className="text-cream-soft/60 hover:text-cream">
                <X size={14} />
              </button>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
